import React from 'react';
import Reveal from './Reveal';
import { photos } from '../photos';

export default function Vision({ t }) {
  const v = t.vision;

  return (
    <section className="relative bg-ink text-snow">
      <div className="relative min-h-[460px] flex items-end">
        <img src={photos.run} alt={t.media.run} className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-ink/90 via-ink/60 to-ink/25" />
        <div className="relative max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-10 py-20">
          <Reveal>
            <p className="font-display text-xs tracking-[0.32em] uppercase text-volt">07 — {v.kicker}</p>
            <h2 className="mt-4 font-display uppercase text-4xl sm:text-6xl leading-[0.9] max-w-3xl tracking-tight">{v.title}</h2>
            <p className="mt-6 max-w-2xl text-xl sm:text-2xl font-medium leading-snug text-snow/90">“{v.statement}”</p>
          </Reveal>
        </div>
      </div>

      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-10 grid md:grid-cols-3">
        {v.cards.map((card, i) => (
          <Reveal key={card.title} delay={i * 80}>
            <article className="h-full p-8 border-t md:border-t-0 md:border-l border-white/10 first:border-l-0">
              <p className="font-display text-volt text-sm tracking-[0.2em]">0{i + 1}</p>
              <h3 className="mt-3 font-display text-3xl uppercase leading-none tracking-tight">{card.title}</h3>
              <p className="mt-4 text-snow/70 leading-relaxed">{card.desc}</p>
            </article>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
